module.exports = __webpack_public_path__ + "user-bg.d763a43bbc4130ad09b3.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/images/user-bg.jpg
// module id = ../../../../../src/assets/images/user-bg.jpg
// module chunks = 29